import { ApiError } from "../api/client";

/** Only known editable team fields can become inline errors or focus targets. */
export function teamFieldErrors(error: unknown): Record<string, string> {
  if (!(error instanceof ApiError) || ![400, 403, 409].includes(error.status) ||
    !["EVENT_INVALID_REQUEST", "EVENT_MEDIA_INVALID", "EVENT_TEAM_AFFILIATION_INVALID", "EVENT_CONSENT_REQUIRED"].includes(error.code)) return {};
  const rows = error.details.fieldErrors;
  if (!Array.isArray(rows) || rows.length > 10) return {};
  const result: Record<string, string> = {};
  for (const row of rows) {
    if (!row || typeof row !== "object" || !["name", "description", "logoMediaId", "affiliatedPartyId"].includes(row.field) ||
      typeof row.message !== "string" || !row.message.trim() || row.message.length > 1000) continue;
    result[row.field] = row.message;
  }
  return result;
}
